import { useQuery } from "@tanstack/react-query";
import { getAllCredentials, getCredentials } from "../../api";

export const useGetCredentials = (page) => {
  const query = useQuery({
    queryKey: ["credentials", page],
    queryFn: () => getCredentials(page),
  });

  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetAllCredentials = () => {
  const query = useQuery({
    queryKey: ["credentials"],
    queryFn: () => getAllCredentials(),
  });

  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};
